// we can't just import and use yup directly because we have
// two separate instances of yup in shared vs api
// wrap all refernces in this file to guarentee it works right
import * as yup from 'yup';
import { beforeToday, isLegalAge } from './methods/date';
import { phone } from './methods/phone';
yup.addMethod(yup.string, 'beforeToday', beforeToday);
yup.addMethod(yup.string, 'isLegalAge', isLegalAge);
yup.addMethod(yup.string, 'phone', phone);
export { yup };
